import { z } from 'zod/v4';

export const speedCoachingProfileSchema = z.object({
  Name: z.string(),
  infractionSpeedLimit: z.number(),
  infractionTimeLimit: z.number(),
  isDefault: z.boolean(),
  numberOfAssignedVehicleGroups: z.number(),
  speedCoachingProfileId: z.number(),
  warningSpeedLimit: z.number(),
  warningTimeLimit: z.number(),
});

export type SpeedCoachingProfile = z.infer<typeof speedCoachingProfileSchema>;
